const Routes = [
  {
    path: '/daily-sales',
    name: 'DailySales',
    component: () => import('@/app/daily_sales/TheDailySales'),
    redirect: { name: 'DailyTrend' },
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DailySalesIndex',
        component: () => import('@/app/daily_sales/views/Index'),
        redirect: { name: 'DailyTrend' },
        children: [
          {
            path: 'daily-trend',
            name: 'DailyTrend',
            component: () => import('@/app/daily_sales/views/DailyTrend')
          }
        ]
      },
      {
        path: 'day/:date',
        name: 'DailyDetailGrid',
        component: () => import('@/app/daily_sales/views/DailyDetailGrid'),
        props: true
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/daily_sales/Routes.js